export default "__VITE_ASSET__DQw444Ac__"